import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { useMemo } from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../../../../../../components/Tooltip';
import { styleSheet } from './styles';

interface IProps {
	event: Api.MeetingEventViewModel;
	contactName: string;
	contactEmailAddresses: Api.EmailAddress[];
	// contactId?: string; // Add contact ID to filter out main contact from attendees
}

export const MeetingTitle = ({ event, contactName, contactEmailAddresses }: IProps) => {
	const item = useMemo(() => {
		return event.toJs();
	}, [event]);

	// Get meeting data if available (meetings might have attendees)
	const flattenedEmailList = useMemo(() => {
		return contactEmailAddresses?.map(email => email.value) || [];
	}, [contactEmailAddresses]);

	const emailList = useMemo(() => {
		const toEmails = item.toEmails || [];
		return toEmails.filter(email => {
			return !flattenedEmailList.includes(email);
		});
	}, [flattenedEmailList, item]);

	const creatorName = useMemo(() => {
		return [item.creator?.firstName, item.creator?.lastName].filter(Boolean).join(' ');
	}, [item]);

	const eventType = useMemo(() => {
		if (event.type === Api.TimelineEventType.MeetingEvent) {
			return 'had a Meeting';
		}

		return 'scheduled a Meeting';
	}, [event]);

	const title = useMemo(() => {
		return `${creatorName} ${eventType} with ${contactName}`;
	}, [creatorName, eventType, contactName]);

	return (
		<div>
			<span>{title}</span>
			{emailList.length > 0 && (
				<Tooltip>
					<TooltipTrigger>
						<span className={css(styleSheet.emailCountBadge)}>+{emailList.length}</span>
					</TooltipTrigger>
					<TooltipContent styles={[styleSheet.tooltipContent]}>
						<ul className={css(styleSheet.emailList)}>
							{emailList.map(email => (
								<li className={css(styleSheet.emailItem)} key={email}>
									{email}
								</li>
							))}
						</ul>
					</TooltipContent>
				</Tooltip>
			)}
		</div>
	);
};
